import "../Styles/Employee_sign.css";
import { Link, useNavigate } from "react-router-dom";

const Clientlogin = () => {
  const navigate = useNavigate();

  const handleJoin = () => {
    // Logic to verify code can be added here
    navigate("/browseagents");
  };

  const handleClient = () => {
    // navigate("/DisplayAgentsForClient");
    navigate("/client-profile-selection");
  };
  const loginType = "Client";
  return (
    <div className="employee-wrapper">
      <div className="employee-header">
        <div className="header-left">
          <img
            src={require("../assests/images/agent-login-signup-top-logo.png")}
            alt="Logo"
            className="header-logo"
          />
        </div>
        <div className="header-right">
          <span
            className="header-signup "
            // onClick={() => navigate("/loginpage", { state: { loginType } })}
          >
           Signup | configuration
          </span>
          <div className="underline-for-agent"></div>
        </div>
      </div>

      <div className="emp">
        <div className="employee-container">
          {/* <img
            src={require("../assests/images/Agent-default-icon.png")}
            alt="Profile"
          /> */}
          {/* <h2> Do you have an agent?</h2> */}
          <div className="signup-title-for-client">
            Would you like an agent?
          </div>
          <p className="signup-desc-for-client">
            Agents help guide you through the process and improve your chances.
          </p>
          <div
            className="underline-for-agent   mt-0"
            style={{ width: "10%" }}
          ></div>

          <div className="employee-roles">
            <div className="employee-role-card" onClick={() => handleJoin()}>
              <div className="employee-title-for-client">
                yes I’d like an agent’s help
              </div>
              <div className="employee-title-for-desc">
                Connect with a verified agent to guide your matrimony journey
              </div>
            </div>

            <div className="employee-card" onClick={() => handleClient()}>
              <div className="employee-title-for-client">
                No I’ll manage alone
              </div>
              <div className="employee-title-for-desc">
                Continue without an agent and explore matches directly.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="emp_footer_line"></div>
    </div>
  );
};

export default Clientlogin;
